import { createSelector } from '@reduxjs/toolkit'
import { selectForm } from './selectForm'
import { FormRootState } from './formStore'
import { useFormSelector } from './formStoreHooks'
import _ from 'lodash'
import { shallowEqual } from 'react-redux'

export const selectConcept = (state: FormRootState, cid?: string) => {
	if(!cid) {
		return null
	}
	const concepts = selectForm(state).concepts
	return concepts[cid] || null
}

export const useConcept = (cid?: string) =>
	useFormSelector(state => selectConcept(state, cid))

export const selectConcepts = (state: FormRootState, cids: string[]) =>
	_.pick(selectForm(state).concepts, cids)

// avoid re-rendering the control
// if none of the applicable conceptStatuses have changed
// see selectConceptStatus2.test.js for validation
export const useConcepts = (cids: string[]) =>
	useFormSelector(state => selectConcepts(state, cids), shallowEqual)

export const selectConceptsArray = (state: FormRootState, cids: string[]) =>
	_.values(_.pick(selectForm(state).concepts, cids))

export const useConceptsArray = (cids: string[]) =>
	useFormSelector(state => selectConceptsArray(state, cids), shallowEqual)

export const selectConceptActivation = (state: FormRootState, cid?: string) =>
	cid ? state.form.conceptActivation[cid] : null

export const useConceptActivation = (cid?: string) =>
	useFormSelector(state => selectConceptActivation(state, cid))
